
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilter.vue";
  import GET_USER_LOCATIONS from "@/apollo/autocomplete-queries/GetUserLocations.gql";
  import DropdownOption from "@/entities/DropdownOption";
  import { Query_RootUser_ProfileArgs } from "@/generated/graphql";

  @Component({
    components: {
      DropdownFilter,
    },
    apollo: {
      locations: {
        query: GET_USER_LOCATIONS,
        variables() {
          return this.locationAutocompleteFilter;
        },
        update(data) {
          return data.userLocations;
        },
        skip() {
          return !this.locationSearchString;
        },
      },
    },
  })

  export default class UserLocationsMultiselect extends Vue {
    @Prop({required: true, type: Array}) value!: DropdownOption[];
    @Prop({ default: true, type: Boolean }) withBorder!: boolean;

    locations: DropdownOption[] = [];
    locationSearchString = "";

    get mappedLocationValue(): String[] {
      return this.value.map((item) => item.name);
    }
  
    get locationAutocompleteFilter():Query_RootUser_ProfileArgs {
      const conditions: any[] = [];
      if (this.locationSearchString.length) {
        conditions.push( { 
            location: { 
              _ilike: `%${this.locationSearchString}%` 
            }, 
          },
        );    
      }

      if (this.mappedLocationValue.length) {
        conditions.push(
          { 
            location: { 
              _nin: this.mappedLocationValue 
            },
          },
        );
      }
      return {
        where: { _and: conditions },
        limit: 5,
      };
    }

    handleInput(val: DropdownOption[]) {
      this.$emit("input", val);
      this.locations = [];
    }
  }
